var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia } from '@joint/plus';
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'rect',
                selector: 'marker'
            }];
        return _this;
    }
    Header.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'kanban.Header', attrs: {
                root: {
                    pointerEvents: 'none'
                },
                label: {
                    x: 'calc(0.5 * w)',
                    fontSize: 24,
                    fontFamily: 'Helvetica',
                    fontWeight: 'Normal',
                    stroke: 'none',
                    textAnchor: 'middle',
                    textVerticalAnchor: 'top'
                },
                marker: {
                    y: 'calc(h - 10)',
                    height: 10,
                    width: 'calc(w)',
                    stroke: 'none',
                }
            }, z: -2 });
    };
    Header.isHeader = function (cell) {
        return cell.get('type') === 'kanban.Header';
    };
    return Header;
}(dia.Element));
export { Header };
